// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  background: #fff;
  height: 100vh;
  /* Full viewport height */
  display: flex;
  flex-direction: column;
}

#wrap {
  height: 100vh;
  /* Full viewport height */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #002f5f;
  color: #fff;
}

.header {
  background: #002f5f;
  color: #fff;
  text-align: center;
}
.header h2 {
  font-size: 1.2em;
}

.chat-window {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  overflow: hidden;
}

.message-list {
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px;
  background-color: #fff;
}

.message-form {
  background-color: #f2f2f2;
  padding: 20px;
  border-top: 1px solid #ddd;
  display: flex;
  align-items: center;
  /* Vertically align the input and button */
}

.ant-list-item-meta-description {
  color: #444 !important;
}

.message-form input {
  flex-grow: 1;
  padding: 10px;
  margin-right: 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  min-width: 0;
  /* Ensure input shrinks properly */
}

.message-form button {
  padding: 10px 15px;
  background-color: #002f5f;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.message-form button:disabled {
  background-color: #b3b3b3;
  cursor: not-allowed;
}

.sendButton {
  line-height: 0.1;
  padding: 20px !important;
}

.end-message {
  color: #333;
  padding: 20px;
  overflow: auto;
  font-size: 1em;
}`, "",{"version":3,"sources":["webpack://./src/style.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,8JAAA;EAGA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AADF;;AAIA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;AADF;AAGE;EACE,gBAAA;AADJ;;AAKA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,kCAAA;AAFF;;AAKA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,yBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,wBAAA;AAFF;;AAKA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;AAFF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  background: #fff;\n  height: 100vh;\n  /* Full viewport height */\n  display: flex;\n  flex-direction: column;\n}\n\n#wrap {\n  height: 100vh;\n  /* Full viewport height */\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #002f5f;\n  color: #fff;\n}\n\n.header {\n  background: #002f5f;\n  color: #fff;\n  text-align: center;\n\n  h2 {\n    font-size:1.2em;\n  }\n}\n\n.chat-window {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  overflow: hidden;\n}\n\n.message-list {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 10px;\n  background-color: #fff;\n}\n\n.message-form {\n  background-color: #f2f2f2;\n  padding: 20px;\n  border-top: 1px solid #ddd;;\n  display: flex;\n  align-items: center;\n  /* Vertically align the input and button */\n}\n\n.ant-list-item-meta-description {\n  color:#444 !important;\n}\n\n.message-form input {\n  flex-grow: 1;\n  padding: 10px;\n  margin-right: 10px;\n  border-radius: 5px;\n  border: 1px solid #ddd;\n  min-width: 0;\n  /* Ensure input shrinks properly */\n}\n\n.message-form button {\n  padding: 10px 15px;\n  background-color: #002f5f;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.message-form button:disabled {\n  background-color: #b3b3b3;\n  cursor: not-allowed;\n}\n\n.sendButton {\n  line-height:0.1;\n  padding:20px !important;\n}\n\n.end-message {\n  color:#333;  \n  padding: 20px;\n  overflow: auto;\n  font-size:1em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
